import { render, staticRenderFns } from "./paymentThankYou.vue?vue&type=template&id=432764a4&scoped=true"
import script from "./paymentThankYou.vue?vue&type=script&lang=js"
export * from "./paymentThankYou.vue?vue&type=script&lang=js"
import style0 from "./paymentThankYou.vue?vue&type=style&index=0&id=432764a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432764a4",
  null
  
)

export default component.exports